import React from "react";
import { UpdateParameterValues } from "../services/City";
function Financing(props) {
  const [value, setValue] = React.useState(null);
  const [isChecked, setIsChecked] = React.useState(null);
  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [structureType, SetstructureType] = React.useState("Per Home");
  const [IsReadOnly, SetReadOnly] = React.useState(false);
  React.useEffect(() => {
    if (props.id == 271 || props.id == 272 || props.id == 273) {
      if (props.id == 271) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("loan");

          parentDiv.style.display = "none";

        }
        else setIsChecked(true);
      }
      if (props.id == 272) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("cons");

          parentDiv.style.display = "none";

        }
        else setIsChecked(true);
      }
      if (props.id == 273) {
        if (props.value == "false") {
          setIsChecked(false);

          var parentDiv = document.getElementById("ext");

          parentDiv.style.display = "none";

        }
        else setIsChecked(true);
      }
    }
    if (props.IsManual == 1) {
      SetReadOnly(true);
    }
    if (props.id == 266 || props.id == 267) {
      SetStyle("form-control construction Prowidth");
    }
    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }

    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }

  }, []);

  const onChange = (e) => {
    setValue(e.target.value);
    let checkid = e.target.id;
    let parameterid = checkid.split('-')[1]
    let structuretype = "";
    if (checkid.includes("Single Family")) {
      structuretype = "Single Family"
    }
    if (checkid.includes("Townhome")) {
      structuretype = "Townhome"
    }
    if (checkid.includes("Cottage")) {
      structuretype = "Cottage"
    }
    if (checkid.includes("Rowhouse")) {
      structuretype = "Rowhouse"
    }
    if (checkid.includes("Condo")) {
      structuretype = "Condo"
    }
    if (checkid.includes("Apartment")) {
      structuretype = "Apartment"
    }
    UpdateParameterValues(structuretype, props);
  }







  if (props.id == 277) {
    return (
      <>
        <div class="col-md-5 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <div class="test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                readOnly
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }

  if (props.id == 274) {

    return (
      <>
        <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <div class="test">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                class={IsStyle}
                readOnly
              />
            </div>
          </div>
        </div>
        <div class="col-md-6" style={{ marginTop: "1%" }}></div>
      </>
    );
  }

  if (props.id == 271 || props.id == 272 || props.id == 273) {

    return (
      <div class="row" style={{ width: "100%" }}>

        <div class="col-md-10" style={{ marginLeft: "2%" }}><span >{props.name.split('Per')[0]}</span></div>
      </div>
    );
  }

  if (props.id == 266 || props.id == 267) {
    return (
      <>

        <div class="col-md-1 col-2" style={{ marginTop: "1%", padding: "0px", marginRight: "1%", marginLeft: "-1%" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <div class="test2">
              <input
                style={{ paddingLeft: "1.5em", paddingRight: "0em" }}
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                readOnly
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 58 || props.id == 62 || props.id == 65) {
    return (
      <>
        <div class="row" style={{ width: "100%" }}>
          <div class="col-md-3"></div>
          <div class="col-md-9" style={{ marginTop: "2%", borderTop: "1px solid rgba(0, 0, 0, 0.2)", width: "102%" }}></div >
        </div>
        <div class="row" style={{ width: "102%" }}>

          <div class="col-md-5" style={{ marginTop: "1%" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 66) {
    return (
      <>

        <div class="row" style={{ width: "100%" }}>

          <div class="col-md-5" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}></div>
          <div class="col-md-4 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 265 || props.id == 276) {
    return (
      <>
        <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <label class=" financinglable ">{props.name.split('Per')[0]}
            </label>



          </div>
        </div>
        <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
          <div class="from  d-flex justify-content-between  align-items-center ">
            <div class="test1">
              <input
                type="text"
                key={props.structureType + "-" + props.id}
                id={props.structureType + "-" + props.id}
                value={value}
                onChange={onChange}
                readOnly
                class={IsStyle}

              />
            </div>
          </div>
        </div>
      </>
    );
  }
  if (props.id == 263 || props.id == 268 || props.id == 4227) {
    if (props.id == 4227) {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (
        <>
          <div class="col-md-2 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }
  if (props.id == 179 || props.id == 264 || props.id == 178 || props.id == 212 || props.id == 213 || props.id == 64) {
    if (props.id == 212 || props.id == 213) {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    if (props.id == 64) {
      return (
        <>
          <div class="col-md-5 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-2 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div >
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  else {
    if (props.id == 57 || props.id == 81 || props.id == 59 || props.id == 60 || props.id == 211 || props.id == 274 || props.id == 275) {
      return (
        <>
          <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <label class=" financinglable ">{props.name.split('Per')[0]}
              </label>



            </div>
          </div>
          <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="test1">
                <input
                  type="text"
                  key={props.structureType + "-" + props.id}
                  id={props.structureType + "-" + props.id}
                  value={value}
                  onChange={onChange}
                  readOnly
                  class={IsStyle}

                />
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      if (props.id == 56 || props.id == 64 || props.id == 61) {
        return (
          <>
            <div class="col-md-3 col-6" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
              <div class="from  d-flex justify-content-between  align-items-center ">
                <label class=" financinglable ">{props.name.split('Per')[0]}
                </label>



              </div>
            </div>
            <div class="col-md-3 col-6" style={{ marginTop: "1%" }}>
              <div class="from  d-flex justify-content-between  align-items-center ">
                <div >
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
      else {
        return (
          <>
            <div class="col-md-3 col-5" style={{ marginTop: "1%", paddingRight: "0px", paddingLeft: "0px" }}>
              <div class="from  d-flex justify-content-between  align-items-center ">
                <label class=" financinglable ">{props.name.split('Per')[0]}
                </label>



              </div>
            </div>
            <div class="col-md-3 col-5" style={{ marginTop: "1%" }}>
              <div class="from  d-flex justify-content-between  align-items-center ">
                <div class="test">
                  <input
                    type="text"
                    key={props.structureType + "-" + props.id}
                    id={props.structureType + "-" + props.id}
                    value={value}
                    onChange={onChange}
                    readOnly
                    class={IsStyle}

                  />
                </div>
              </div>
            </div>
          </>
        );
      }
    }
  }
}
export default Financing;
